import styles from './components.module.css'

export type ConfidenceIntervalType = {
  lower: number
  upper: number
}

export function ConfidenceInterval({
  confidenceInterval,
  growth,
}: {
  confidenceInterval: ConfidenceIntervalType
  growth: number
}) {
  return (
    <>
      <div className={styles['confidenceInterval-datapoint']}>
        {confidenceInterval.lower}%
      </div>
      <div
        className={`${styles['confidenceInterval-gap']} ${growth <= 0 ? styles['confidenceInterval-lowValue'] : ''}`}
      >
        {growth}
      </div>
      <div className={styles['confidenceInterval-datapoint']}>
        {confidenceInterval.upper}%
      </div>
    </>
  )
}
